import React from "react";
import { t } from "ttag";

import { IFormUUID } from "../../../models/nominals";
import { useAppSelector } from "../../reducers";
import { WriteReviewFormMode } from "../constants";
import { getWriteReviewFormMode } from "../selectors";

interface IProps {
    formUUID: IFormUUID;
}

export const WriteReviewThankYou = (props: IProps): React.ReactNode => {
    const isOpen = useAppSelector((state) => {
        const displayMode = getWriteReviewFormMode(state.reviews, props);
        return displayMode === WriteReviewFormMode.THANK_YOU_OPEN;
    });

    if (!isOpen) {
        return null;
    }
    return (
        <div className="review-thank-you" role="alert">
            <h2 className="review-thank-you__title">
                {t`Thank You for Writing a Review`}
            </h2>
            <p>
                {t`We appreciate your feedback and comments, and always enjoy hearing from you.`}
            </p>
            <p>
                {t`Return to the `}
                <a
                    title={t`Home`}
                    href="/"
                    className="review-thank-you__home"
                    target="_self"
                >
                    {t`homepage`}
                </a>
                <span>.</span>
            </p>
        </div>
    );
};
